import {COLOR_MAP} from 'theme/store/themeApi';
import {hexToRgb} from 'shared/helpers';
import {Branding} from 'store/customer/brandingSlice';
import {Colours} from 'theme/types';
import {baseTheme} from 'theme/baseTheme';

const setTitle = (branding: Branding, skipTitle?: boolean) => {
    if (!skipTitle) {
        document.title = branding.branding_manufacturer_name;
    }

    const favicon = document.getElementById('favicon') as HTMLLinkElement;

    if (favicon) {
        favicon.href = branding.branding_manufacturer_favicon;
    }
};

// NOTE: we are not yet getting rid of this yet
// as a lot of the code is still using this
// we will remove this once we have refactored
// most of our components to use styled-components
const setColors = (colors: Colours) => {
    const root = document.documentElement;

    Object.keys(colors).forEach((key) => {
        const cssVarKey = COLOR_MAP[String(key)];
        const colorKey = key as keyof Colours;
        // eslint-disable-next-line security/detect-object-injection -- key only ever comes from the known COLOR_MAP
        const color = colors[colorKey];
        const colorRGB = hexToRgb(color.main) as string;

        root.style.setProperty('--' + cssVarKey, colorRGB);
    });
};

// a theme colour at partial opacity, so surfaces follow the manufacturer's
// branding instead of a hardcoded pale blue
export const tint = (color: string, alpha: number) =>
    `rgba(${hexToRgb(color) as string}, ${alpha})`;

export const setTitleAndBranding = (
    branding: Branding,
    colors?: Colours,
    skipTitle?: boolean
) => {
    setTitle(branding, skipTitle);
    if (colors) {
        // safe override for the pro settings page only, lets not include all value from base theme as all may not be compatible
        const baseColours = {
            primary: baseTheme.colors.primary,
            secondary: baseTheme.colors.secondary,
            headerColour: baseTheme.colors.headerColour,
            headerNavigationColor: baseTheme.colors.headerNavigationColor,
        };
        setColors({...baseColours, ...colors});
    }
};
